import { defineMessages } from 'react-intl';

export default defineMessages({
  emptyStateTryHeader: {
    id: 'frontbucket.jiraPage.overview.emptyStateTryHeader',
    description: 'Header of jira page empty state screen',
    defaultMessage:
      'Project and issue tracking with Jira Cloud. Free for small teams.',
  },
  tryJiraFreeButton: {
    id: 'frontbucket.jiraPage.tryJiraFreeButton',
    description: 'A button that redirects to try jira in WAC',
    defaultMessage: 'Try Jira free',
  },
  tertiaryText: {
    id: 'frontbucket.jiraPage.tertiaryText',
    description: 'Tertiary text about trying Jira free',
    defaultMessage:
      'Scrum and kanban boards. Automated workflows. Free for 10 users.',
  },
  tertiaryTextTryNonAdmin: {
    id: 'frontbucket.jiraPage.tertiaryTextTry.nonAdmin',
    description: 'Tertiary text saying workspace admins can sign up for Jira.',
    defaultMessage: 'Only workspace admins can sign up for Jira.',
  },
  learnMoreLink: {
    id: 'frontbucket.jiraPage.learnMoreLink',
    description: 'A link to more information about jira',
    defaultMessage: 'Learn more',
  },
  emptyStateConnectHeader: {
    id: 'frontbucket.jiraPage.overview.emptyStateConnectHeader',
    description: 'Header of jira page empty state screen',
    defaultMessage: 'Connect to Jira Cloud',
  },
  emptyStateConnectDescription: {
    id: 'frontbucket.jiraPage.emptyStateConnectDescription',
    description: 'Descriptive text on jira page empty state screen',
    defaultMessage:
      'Connect your site to see your Jira Cloud projects in this repository.',
  },
  openSettings: {
    id: 'frontbucket.jiraPage.openSettings',
    description: 'A button that redirects to workspace or account settings',
    defaultMessage: 'Open settings',
  },
  tertiaryTextConnectNonAdmin: {
    id: 'frontbucket.jiraPage.tertiaryTextConnect.nonAdmin',
    description:
      'Tertiary text saying workspace admins can connect Jira sites.',
    defaultMessage: 'Only {workspaceLink} admins can connect Jira sites.',
  },
  tryJiraPromoButton1Title: {
    id: 'frontbucket.jiraPage.tryJiraPromoButton1.title',
    description: 'Title for the first promo button on the try Jira page',
    defaultMessage: 'Built for software teams',
  },
  tryJiraPromoButton1Details: {
    id: 'frontbucket.jiraPage.tryJiraPromoButton1.details',
    description: 'Description for the first promo button on the try Jira page',
    defaultMessage: 'Plan, track, and release quality software using Jira.',
  },
  tryJiraPromoButton2Title: {
    id: 'frontbucket.jiraPage.tryJiraPromoButton2.title',
    description: 'Title for the second promo button on the try Jira page',
    defaultMessage: 'Auto-link code to Jira issue',
  },
  tryJiraPromoButton2Description: {
    id: 'frontbucket.jiraPage.tryJiraPromoButton2.description',
    description: 'Description for the second promo button on the try Jira page',
    defaultMessage:
      'Link your commits, branches, and pull requests to a Jira issue.',
  },
  tryJiraPromoButton3Title: {
    id: 'frontbucket.jiraPage.tryJiraPromoButton3.title',
    description: 'Title for the third promo button on the try Jira page',
    defaultMessage: 'Edit Jira issues in Bitbucket',
  },
  tryJiraPromoButton3Description: {
    id: 'frontbucket.jiraPage.tryJiraPromoButton3.description',
    description: 'Description for the third promo button on the try Jira page',
    defaultMessage:
      'View, edit, comment and more on Jira issues within Bitbucket.',
  },
  tryJiraPromoButton4Title: {
    id: 'frontbucket.jiraPage.tryJiraPromoButton4.title',
    description: 'Title for the fourth promo button on the try Jira page',
    defaultMessage: 'Development info in Jira',
  },
  tryJiraPromoButton4Description: {
    id: 'frontbucket.jiraPage.tryJiraPromoButton4.description',
    description: 'Description for the fourth promo button on the try Jira page',
    defaultMessage:
      'View all development activities in Bitbucket from within Jira.',
  },
});
